import { DatalayerFactoryProvider } from "@omnia/shared/layers/datalayerFactory"
import { DatalayerViewManagerProvider } from "@omnia/shared/layers/viewManager"
import { NutrientAppLayer } from "@omnia/shared/nutrition/map/nutrientAppLayer"
import { NutrientAppLayerViewerFactory } from "@omnia/shared/nutrition/map/nutrientAppLayerViewer"
import { RequirementsLayer } from "@omnia/shared/nutrition/map/requirementsLayer"
import { RequirementsLayerViewerFactory } from "@omnia/shared/nutrition/map/requirementsLayerViewer"
import { IDatalayerViewerFactory } from "@omnia/types"
import { PlanApplicationsTableCtrl } from "./dashboard/applications/apps"
import { AppZoneEditorCtrl } from "./dashboard/map/app/edit/edit"
import { MapCtrl } from "./dashboard/map/map"
import { MenuCtrl } from "./dashboard/map/menu/menu"
import { MapEditCtrl } from "./dashboard/map/requirements/edit/edit"
import { MapContextMenuCtrl } from "./dashboard/map/view/context-menu"
import { ZonesCtrl } from "./dashboard/map/zones/zones"
import { DashboardCtrl } from "./dashboard/table/dashboard"
import { createDashboard } from "./dashboard/table/plans/plans"
import { RequirementEditCtrl } from "./dashboard/table/requirements/edit/edit"
import { RequirementsTableCtrl } from "./dashboard/table/requirements/requirementsTable"
import { BiomassLayerViewerFactory } from "./map/biomassLayerViewer"
import { defineMigrateDialog } from "./migrate/ng"
import { NutritionModule } from "./module/module"
import { NotificationsCtrl } from "./notifications/notifications"
import { LayerTypeId } from "./omnia"
import { setupPlanEditor } from "./plan/edit/setup"
import { ConfigDlg } from "./requirements/config/config"
import { BatchEditDlg } from "./requirements/edit/batch/batch"
import { NumbarCtrl } from "./requirements/numbar/numbar"
import { ResetDlg } from "./requirements/reset/reset"
import { CroppingGroupService } from "./services/grouping"
import { NutritionService } from "./services/nutrition"
import { PlanTemplateService } from "./services/templates"

export function setup(module: ng.IModule) {

    module

        .service("OmniaNutritionService", NutritionService)
        .service("OmniaNutritionPlanTemplateService", PlanTemplateService)
        .service("OmniaNutritionCroppingGroup", CroppingGroupService)

        .directive("omniaNutri", NutritionModule.create)

        .directive("omniaNutriNotifications", NotificationsCtrl.create)

        .directive("omniaNutriDashboardMap", MapCtrl.create)
        .directive("omniaNutriDashboardMapContextMenu", MapContextMenuCtrl.create)
        .directive("omniaNutriDashboardMapMenu", MenuCtrl.create)
        .directive("omniaNutriDashboardMapZones", ZonesCtrl.create)
        .directive("omniaNutriDashboardMapAppZonesEdit", AppZoneEditorCtrl.create)
        .directive("omniaNutriDashboardMapRequirementsEdit", MapEditCtrl.create)
        .directive("omniaNutriDashboardAppTable", PlanApplicationsTableCtrl.create)

        .directive("omniaNutriDashboardTable", DashboardCtrl.create)
        .directive("omniaNutriRequirementsTable", RequirementsTableCtrl.create)
        .directive("omniaNutriDashboardPlans", createDashboard)
        .directive("omniaNutriDashboardTableRequirementsEdit", RequirementEditCtrl.create)

        .directive("omniaNutriRequirementsConfig", ConfigDlg.create)
        .directive("omniaNutriRequirementsEditBatch", BatchEditDlg.create)
        .directive("omniaNutriRequirementsReset", ResetDlg.create)

        .directive("omniaNutriNumbar", NumbarCtrl.create)

        .directive("omniaNutriMigrationDialog", defineMigrateDialog)

        .config(["OmniaDatalayersViewManagerProvider", (provider: DatalayerViewManagerProvider) => {

            let viewers: IDatalayerViewerFactory[] = ["P2O5", "K2O", "MgO", "N", "SO3"].map(t => {

                return RequirementsLayerViewerFactory.createForNutrient(t)

            });

            viewers.push(
                BiomassLayerViewerFactory.create(),
                NutrientAppLayerViewerFactory.create()
            );

            provider.register(viewers);


        }])

        .config(["OmniaDatalayersFactoryProvider", (provider: DatalayerFactoryProvider) => {

            provider.register(LayerTypeId.NutrientRequirements, (layer, ctxt) => new RequirementsLayer(layer, ctxt));
            provider.register(LayerTypeId.NutrientApplications, (layer, ctxt) => new NutrientAppLayer(layer, ctxt));

        }]);

    setupPlanEditor(module)

    return module

}
